export default __webpack_public_path__ + "static/media/03.7fbea572.jpg";